<template>
    <v-card>
        <v-card-title class="justify-center">
            <h2>
                Solicitação de Parceiria
            </h2>
        </v-card-title>
        <v-card-text>
            <v-layout wrap justify-space-around>
                <v-flex xs3>
                    <img
                        width="100%"
                        v-if="empresa.url_logo"
                        :src="empresa.url_logo"
                        alt="Logo da empresa"
                        style="border-radius: 10em"
                    >
                    <v-avatar
                        v-else
                        color="primary"
                        size="150"
                        dark
                    >
                        <v-icon size="100" color="white">domain</v-icon>
                    </v-avatar>
                </v-flex>
                <v-flex xs8>
                    <v-flex xs12>
                        Nome Fantasia: <b>{{empresa.nome_fantasia}}</b>
                    </v-flex>
                    <v-flex xs12>
                        Razão Social: <b>{{empresa.razao_social}}</b>
                    </v-flex>
                    <v-flex xs12>
                        CNPJ: <b>{{empresa.cnpj}}</b>
                    </v-flex>
                    <v-flex xs12>
                        Contato: <b>{{empresa.administrador.telefone}}</b>
                    </v-flex>
                    <v-flex xs12>
                        Nome do Representante: <b>{{empresa.administrador.nome}}</b>
                    </v-flex>
                    <v-flex xs12>
                        E-mail: <b>{{empresa.administrador.email}}</b>
                    </v-flex>
                </v-flex>
                <v-flex xs6 v-if="empresa.endereco">
                    Logradouro: <b>{{empresa.endereco.logradouro}}</b>
                </v-flex>
                <v-flex xs6 v-if="empresa.endereco">
                    Número: <b>{{empresa.endereco.numero}}</b>
                </v-flex>
                <v-flex xs6 v-if="empresa.endereco">
                    Bairro: <b>{{empresa.endereco.bairro}}</b>
                </v-flex>
                <v-flex xs6 v-if="empresa.endereco">
                    Cidade: <b>{{empresa.endereco.cidade}}</b>
                </v-flex>
                <v-flex xs6 v-if="empresa.endereco">
                    Estado: <b>{{empresa.endereco.estado}}</b>
                </v-flex>
                <v-flex xs6 v-if="empresa.endereco">
                    CEP: <b>{{empresa.endereco.cep}}</b>
                </v-flex>
                <v-flex xs12 class="mt-2">
                    Site: <b>{{empresa.site}}</b>
                </v-flex>
                <v-flex xs12 class="mt-1">
                    Descrição: <b>{{empresa.descricao}}</b>
                </v-flex>
                <v-flex xs12 class="mt-1">
                    Desconto: <b>{{empresa.desconto_apetrus}}%</b>
                </v-flex>
                <v-flex xs12 class="mt-2">
                    <img
                        v-if="empresa.url_banner"
                        :src="empresa.url_banner"
                        alt="Banner"
                        width="100%"
                        >
                        <v-card v-else width="100%" height="20em" color="primary" dark>
                        <v-layout justify-center align-center fill-height>
                            <v-icon size="200" color="white">image</v-icon>
                        </v-layout>
                        </v-card>
                </v-flex>
            </v-layout>
            <v-layout justify-center class="mt-4">
                <v-flex xs5>
                <v-select
                    solo
                    :items="[
                        { text: 'Aceitar', value: true },
                        { text: 'Rejeitar', value: false }
                    ]"
                    v-model="resposta"
                ></v-select>
                </v-flex>
            </v-layout>
        </v-card-text>
        <v-card-actions class="justify-space-around">
            <v-btn round class="mb-2" @click="$emit('fechar')">Fechar</v-btn>
            <v-btn
                round
                class="mb-2"
                @click="tornarParceira"
                color="success"
            >
                Responder
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    props: ['empresa'],
    data: () => ({
        resposta: false,
        empresa_data: {}
    }),
    beforeMount () {
        this.empresa_data = this.empresa
    },
    methods: {
        tornarParceira () {
            this.empresa_data.aceita = this.resposta
            if (this.resposta) {
                this.empresa_data.is_empresa_parceira = this.resposta
            }
            this.$store.dispatch('tornarParceira', this.empresa_data)
                .then(() => {
                    this.$emit('success', `Solicitação ${this.resposta ? 'aceita' : 'rejeitada'} com sucesso`)
                    this.$emit('carregar')
                    this.$emit('fechar')
                })
        }
    }
}
</script>
